// extracted by mini-css-extract-plugin
export default {"Emojis__item":"bge_a bic_wj bic_ss bic_xl"};